<template>
  <div class="page">
    <div class="head">
      <p class="text">北京赢科天地电子有限公司成立于2008年，专业为高校信息化建设提供技术解决方案和相关产品服务，是北京市和中关村高新技术企业。公司下设2个研究室、4个研发基地和6个区域分公司，拥有2项国家专利、40余款自主知识产权软件产品，是北京市软件企业和中国先进技术企业。<br>
	  赢科天地致力于成为中国领先的高等教育信息化产品和服务供应商，为高校提供架构先进、技术成熟、功能强大、运行稳定的软件产品，竭诚期待与您的合作，您的满意就是我们最大的动力和不懈追求的坚定目标！
	  </p>
    </div>
    <div class="title">赢科愿景</div>
    <div class="box-wrap">
      <div class="box box-left">
        <div class="grid"></div>
        <div class="grid">
          <div>
            <p class="en">Informatization</p>
            <p class="chinese">信息化</p>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="grid grid1"></div>
        <div class="grid grid2">
          <div>
            <p class="en">Normalization</p>
            <p class="chinese">标准化</p>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="grid grid3">
          <div>
            <p class="en">Creativity</p>
            <p class="chinese">创造性</p>
          </div>
        </div>
        <div class="grid grid4"></div>
      </div>
      <div class="box">
        <div class="grid grid5"></div>
        <div class="grid grid6">
          <div>
            <p class="en">Optimization</p>
            <p class="chinese">最优化</p>
          </div>
        </div>
      </div>
    </div>
    <div class="company-warp">
      <div class="head-title">企业布局</div>
      <div class="container">
        <div class="card-top-wrap">
          <div class="card bg">
            <div class="title">2008
              <span class="des">年</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;">成立</p>
          </div>
          <div class="card bg">
            <div class="title">16
              <span class="des">年</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;">行业实践经验</p>
          </div>
          <div class="card">
            <div class="title">6
              <span class="des">个</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;color: #000000;">分公司</p>
          </div>
        </div>
        <div class="card-bottom-wrap">
          <div class="card bg">
            <div class="title">120
              <span class="top-des">十</span>
			  <span class="des">个</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;">合作高校</p>
          </div>
          <div class="card">
            <div class="title">40
				<span class="top-des">十</span>
              <span class="des">项</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;">知识产权</p>
          </div>
          <div class="card bg">
            <div class="title">4
              <span class="des">个</span>
            </div>
            <p style="line-height: 15px;font-size: 12px;">研发中心</p>
          </div>
        </div>
        <br>
        <div class="title">诚信合作，创新共享</div>
        <div class="description">
			赢科天地是北京市和中关村高新技术企业、中国先进技术企业、中国音像与数字出版协会音视频工程专业委员会理事单位、中国高等教育协会产教融合研究分会会员单位、北京高校优质课程研究会秘书长单位。公司已通过 CMMI3、ISO9000/20000 系列质量管理体系认证，拥有信息系统集成及服务、音视频工程企业、音视频集成工程企业等多项权威行业资质，荣获中国自主创新产品评价，被权威评估机构认定为 3A 级资信企业、重合同守信用企业、质量服务诚信企业，被北京软件和信息服务协会评为北京软件企业创新型和成长型核心竞争力企业。过十多年持续发展，公司综合实力、品牌影响力显著提升，先后荣获中国教育软件行业最具影响力品牌、中国自主创新企业、中国在线教育十强企业、质量信得过企业等殊荣，经权威机构评选，赢科天地获得全国教育软件行业市场用户首选品牌荣誉，全国各大高等院校的认可也极大地提升了公司的品牌认知度和美誉度。
        </div>
		</div>
    </div>
    <div class="title" style="line-height: 60px;background:#fff;">发展历程</div>
    <div style="background:rgb(247,249,250)">
      <div class="page1">
        <div class="top-box">
          <swiper class="swiper2" ref="swiperTop" :options="swiperOption3">
            <swiper-slide v-for="(item, index) of devList" :key="item.ellipsis+''+index">
              <div class="box">
                <p class="time">{{item.remark01}}</p>
                <p class="title">{{item.title}}</p>
                <p class="text" :class="{'ellipsis': item.ellipsis}" v-html="item.content">
                </p>
                <p class="showP" :ref="item.id" v-html="item.content"></p>
              </div>
              <div style="height: 30px;"></div>
              <!-- <div v-if="item.showBtn" class="more" @click="ellipsisClick(item, index)">
                查看更多
                <Icon type="ios-arrow-forward" />
              </div> -->
            </swiper-slide>
          </swiper>
        </div>
        <div class="right">
          <!-- @click.native="handleSwiperDOMClick" -->
          <swiper class="swiper1 gallery-thumbs" ref="swiperThumbs" :options="swiperOption4">
            <swiper-slide v-for="(item, index) in devList" :key="index">
              <p class="time">{{item.remark01}}</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div style="background: rgb(231,245,252)" ref="backTop1">
      <div class="news-wrap">
        <div class="news-title" >新闻中心</div>
        <div class="swiper-box" >
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="(item, index) of newsList" :key="index">
              <div>
                <div class="image" :style="{backgroundImage: 'url(' + item.img + ')'}"></div>
                <p class="title" style="line-height: 25px;">{{item.title}}</p>
                <div class="des">
                  <span class="text">{{item.date}}</span>
                  <Icon class="icon" @click="jumpPdf(item.id)"  type="ios-arrow-dropright" size="24" style="cursor: pointer;"/>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <div class="honor-wrap">
      <div class="honer-top">
        <div class="title">赢科荣誉</div>
        <div class="container">
          <div class="swiper-box">
            <swiper class="swiper" :options="swiperOption1">
              <swiper-slide v-for="(item, index) of honorList" :key="index">
                <div class="honor-item">
                  <div class="honor-item-top">
                    <div class="honor-image" :style="{backgroundImage: 'url(' + item.img + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'}"></div>
                  </div>
                  <p class="title">{{item.title}}</p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
    </div>
    <div>
      <div style="width: 1000px;height: 50px; margin: 0 auto;background: rgb(247, 249, 250);"></div>
    </div>

  </div>
</template>

<script>
import _news_data from './news.js'
export default {
  name: 'HelloWorld',
  data() {
    return {
	    topHeight: 0,
      currentIndex: 0,
      grid: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOption1: {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      swiperOption3: {
        direction: 'vertical',
        slidesPerView: 'auto',
      },
      swiperOption4: {
        direction: 'vertical',
        spaceBetween: 20,
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
      },
      devList: [
        {
          title: '深化高校合作 拓展服务版图',
          remark01: '2026',
          id: '2026',
          content: '<div><p>深耕高等教育信息化领域，提供未来学习中心、教务系统建设、平台运维等服务，服务广度与深度扩大。教学智能体产品入选教育部首批高等教育智能体。</p></div>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '构建智慧学习矩阵 共建未来学习中心',
          remark01: '2025',
          id: '2025',
          content: '<div><p>围绕在线学习、本研教务等核心场景形成"智慧学习"产品矩阵；与多所高校合作共建未来学习中心，深度参与教育部试点院校建设。</p></div>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '获评专精特新 产品屡获认可',
          remark01: '2024',
          id: '2024',
          content: '<div><p>获评北京市"专精特新"中小企业，进入加速拓展期。"智学北航"平台完成升级并上线移动端，相关成果先后入选教育部首批、第二批"人工智能+高等教育"应用场景典型案例。</p></div>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '“融优学堂”成为“国家智慧教育平台”首批接入平台',
          remark01: '2022',
          id: '2022',
          content: '<p>2022年3月28日，教育部举行“国家智慧教育平台”启动仪式。教育部党组书记、部长怀进鹏出席仪式并宣布“国家智慧教育平台”正式上线。经教育部高教司严格遴选，“融优学堂”等20个在线开放课程平台获批成为“国家高等教育智慧教育平台”首批接入平台，“融优学堂”首批推出《思维训练与学习力提升》《武器装备概论》《人工智能》《魅力机器人》《数据挖掘与分析》等特色精品课程近百门。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '荣获中国自主创新产品认证',
          remark01: '2021',
          id: '2021',
          content: '<p>赢科天地积极开拓创新技术应用模式，开发出“教师教学档案袋”系统，并积极参与“延河高校人才培养联盟资源共享信息平台”“沙河高教园区高校联盟资源共享信息平台”创建工作。通过软件产品的自主开发，赢科天地于本年度获得了中国自主创新产品认证。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '开拓进取 勇担责任',
          remark01: '2020',
          id: '2020',
          content: '<p>赢科天地坚持开拓进取的精神，发布了“在线教学平台”，成立济南研发中心；并通过了中关村高新技术企业、诚信系统集成企业认证和CMMI3软件成熟度认证。</p><p>赢科天地自主研发的“融优学堂”为疫情期间高校“停课不停教、不停学”贡献了积极力量，为此，赢科天地荣获“疫情期间作出重要贡献的在线教学企业”表彰。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '扩大投资规模',
          remark01: '2019',
          id: '2019',
          content: '<p>赢科天地顺应公司发展需求，投资规模增至5000万元，并成立华东分公司、西南分公司和南京研发中心。</p><p>公司专研教育部政策文件，于本年发布了“职业院校内部质量保证体系诊断与改进平台”，为职业院校教学诊断与改进工作提供了技术支持。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '“本研一体化教学业务管理系统”正式上市',
          remark01: '2018',
          id: '2018',
          content: '<p>以人才培养全业务流程为主线，以整合管理资源、优化管理过程、提升管理效率为目标，倾力打造了“本硕博贯通、教学管评一体”的全新教学业务管理系统。在课程、培养方案、排课、选课、考试、成绩、评价、学籍、毕业等各业务领域实现了功能统筹和数据互通，为高校教学业务信息化管理提供了一站式解决方案。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '“融优学堂”上线运行',
          remark01: '2016',
          id: '2016',
          content: '<p>融优学堂MOOC平台，实现了首都高校优质课程共建共享，推动深化基于MOOC的课程教学改革。不仅提供MOOC教学必备的建课、用课、评课等基础功能，还研发了课程群、线上见面课、防双刷双替等特色功能。同时，为课程质量评价审核、跨校供选课、学分互认三大课程共建共享机制提供了完善的功能服务和技术支撑。</p><p>赢科天地于本年度荣获北京市高新技术企业和信息系统集成资质认证。同时，为扩展公司业务，更好的服务华南地区高校，赢科天地成立了华南分公司。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '发起成立“北京高校优质课程研究会”',
          remark01: '2015',
          id: '2015',
          content: '<p>为开展优质教学资源共建共享研究，推动各高校人才培养模式改革，提升教育教学质量，赢科天地发起成立“北京高校优质课程研究会”，以实现“课程共享、学分互认、提升教学质量、深化教学改革”的目标，构建平台、课程、机制、研究的建设体系。通过对高等教育政策的研究，赢科天地创新技术应用模式，研发了“教学管理一体化信息系统”，为高校信息化教学管理工作提供了技术支持。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '荣获软件企业认定证书',
          remark01: '2013',
          id: '2013',
          content: '<p>赢科天地荣获软件企业认定证书，提升了品牌影响力。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '开发新市场',
          remark01: '2012',
          id: '2012',
          content: '<p>赢科天地为扩展业务领域开发更多软件产品，成立东北分公司和哈尔滨研发中心。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '举办首届“高等学校本科教育教学研讨会”',
          remark01: '2011',
          id: '2011',
          content: '<p>赢科天地联合北京航空航天大学、北京大学、中国人民大学、北京理工大学、四川大学等高校，在北京蟹岛度假村举办了首届“高等学校本科教育教学研讨会”。赢科天地企业质量管理和质量保证能力符合相应标准或有能力按规定的质量要求提供产品，于该年度通过了ISO9000质量管理体系认证。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '首款产品上市',
          remark01: '2010',
          id: '2010',
          content: '<p>赢科天地首款产品——学生成绩管理系统，本年度正式上市。该系统充分发挥信息技术优势，将网络数据库系统与自助打印一体机有机结合，实现了学生成绩的分布式管理与使用，为学生提供了方便快捷的成绩查询打印等服务，极大提升高校成绩管理工作水平。</p>',
          showBtn: true,
          ellipsis: true,
        },
        {
          title: '赢科天地正式成立',
          remark01: '2008',
          id: '2008',
          content: '<p>2008年5月6日，北京赢科天地电子有限公司正式成立。公司致力于成为中国领先的高等教育信息化产品和服务供应商，专业为高校信息化建设提供技术解决方案和相关产品服务。</p>',
          showBtn: true,
          ellipsis: true,
        }
      ],
      newsList: [],
      honorList: [
      {
        img: require('../assets/honor/01.png'),
        title: '诚信系统集成企业',
      },
      {
        img: require('../assets/honor/02.png'),
        title: '软件企业认定证书',
      },
      {
        img: require('../assets/honor/03.png'),
        title: '国家高新技术企业',
      },  
      {
        img: require('../assets/honor/04.png'),
        title: 'CMMI3认证证书',
      },
      {
        img: require('../assets/honor/05.png'),
        title: '信息安全等级保护三级',
      },
      {
        img: require('../assets/honor/06.png'),
        title: '中关村高新技术企业',
      },
      {
        img: require('../assets/honor/07.png'),
        title: '售后服务认证证书',
      },
      {
        img: require('../assets/honor/08.png'),
        title: '信息安全管理体系认证',
      },
      {
        img: require('../assets/honor/09.png'),
        title: '环境管理体系认证',
      },
      {
        img: require('../assets/honor/10.png'),
        title: '质量管理体系认证',
      }],
    }
  },
  methods: {
    ellipsisClick(item, index) {
      item.ellipsis = !item.ellipsis
      // this.$forceUpdate()
      this.$set(this.devList, index, item)
    },
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    jumpPdf(id) {
      let routeUrl = this.$router.resolve({
          path: 'newsdetail',
          query: {id:id}
        });
      window.open(routeUrl.href, '_blank');
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let search = window.location.href.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
  },
  mounted() {
    this.newsList = _news_data
    let url =
      this.HOST +
      'wzPage/getJson?id=D8E4A62A0B6F2C98E05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url = this.$getJsonUrl(url)
    this.$axios.get(url).then((res) => {
      this.devList = res.data.content[0].children[1].children[0].list
      for (let item of this.devList) {
        item.ellipsis = true
      }
      this.newsList = res.data.content[0].children[0].children[0].list.reverse()
      this.honorList = res.data.content[0].children[0].children[1].list
    })
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
    setTimeout(() => {
      this.$nextTick(() => {
        for (let i = 0; i < this.devList.length; i++) {
          let item = this.devList[i]
          if (this.$refs[item.id][0].offsetHeight > 140) {
            item.showBtn = true
            this.$set(this.devList, i, item)
          }
        }
      })
    }, 500)
    if('1'==this.getUrlParam("type")){
      setTimeout(() => {
        this.topHeight = this.$refs.backTop1.getBoundingClientRect().top
        console.log(this.topHeight)
        document.documentElement.scrollTop = this.topHeight
      }, 100)
    }
  },
}
</script>

<style scoped lang="less">
.progress {
  position: absolute;
  top: 0;
  right: 0;
  height: 100px;
}
.page {
  .head {
    background-image: url('../assets/gywm-1.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    .text {
      width: 690px;
      padding: 100px 80px;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
    }
  }
  .card-top-wrap {
    .card {
      display: inline-block;
      width: 140px;
      margin-right: 140px;
      padding: 10px 0;
      text-align: center;
      background: #fff;
      &.bg {
        // background: rgb(69, 163, 50);
        background-image: url('../assets/about-1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .title {
          color: #fff;
        }
      }
      .title {
        position: relative;
        display: inline-block;
        padding-right: 12px;
        padding-top: 0;
        line-height: 46px;
        font-size: 46px;
        font-weight: 600;
        color: #000;
        .des {
          position: absolute;
          bottom: 5px;
          right: -4px;
          line-height: 14px;
          font-size: 14px;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  .card-bottom-wrap {
    margin-top: 80px;
    .card {
      display: inline-block;
      width: 140px;
      margin-left: 193px;
      padding: 10px 0;
      text-align: center;
      background: #fff;
      color: #000;
      &.bg {
        // background: rgb(69, 163, 50);
        background-image: url('../assets/about-2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        color: #fff;
        .title {
          color: #fff;
        }
      }
      .title {
        position: relative;
        display: inline-block;
        padding-right: 12px;
        padding-top: 0;
        line-height: 46px;
        font-size: 46px;
        font-weight: 600;
        color: #000;
        .top-des {
          position: absolute;
          top: 6px;
          right: -2px;
          width: 12px;
          height: 12px;
          line-height: 14px;
          font-size: 14px;
        }
        .des {
          position: absolute;
          bottom: 5px;
          right: -4px;
          width: 14px;
          height: 14px;
          line-height: 14px;
          font-size: 14px;
        }
      }
    }
  }
  .title {
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
  .box-wrap {
    display: flex;
    .box-left {
      flex: 1;
      background-image: url('../assets/gywm-2.jpg');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .box {
      flex: 1;
      .grid {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        color: #fff;
        div {
          position: absolute;
          top: 50%;
          left: 35%;
          transform: translate(-50%, -50%);
          .en {
            font-size: 20px;
            font-weight: 600;
          }
          .chinese {
            font-size: 30px;
            font-weight: bolder;
          }
        }
        &.grid1 {
          background-image: url('../assets/gywm-5.jpg');
          background-repeat: no-repeat;
          background-size: cover;
        }
        &.grid4 {
          background-image: url('../assets/gywm-4.jpg');
          background-repeat: no-repeat;
          background-size: cover;
        }
        &.grid5 {
          background-image: url('../assets/gywm-6.jpg');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      .grid2,
      .grid3,
      .grid6 {
        background: rgb(69, 163, 50);
      }
    }
  }
  .company-warp {
    padding-bottom: 50px;
    text-align: left;
    background-image: url('../assets/gywm-7.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #fff;
    line-height: 1;
    .container {
      width: 1000px;
      margin: auto;
    }
    .head-title {
      padding-bottom: 50px;
      line-height: 60px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #000;
    }
    .title {
      padding-top: 30px;
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      color: #606060;
    }
    .description {
      margin: auto;
      font-size: 16px;
      line-height: 1.3rem;
      color: #606060;
    }
  }
  .news-wrap {
    width: 1000px;
    margin: auto;
    padding-bottom: 60px;
    background: rgb(231, 245, 252);
    .news-title {
      line-height: 100px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
    }

    .image {
      width: 100%;
      height: 0;
      // padding-bottom: 100%;
      padding-bottom: 60%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #999;
    }
    .title {
	    margin: 15px 0;
      text-align: left;
      font-weight: 600;
      line-height: 25px ;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 限制行数为2 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .des {
      position: relative;
      padding: 5px 0 20px 0;
      border-bottom: 1.5px solid #000;
      .text {
        overflow: hidden;
        display: -webkit-box;
        word-break: break-all;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        width: 85%;
        line-height: 16px;
        text-align: left;
        font-size: 12px;
      }
      .icon {
        position: absolute;
        right: 0;
        bottom: 20px;
      }
    }
  }
  .honor-wrap {
    .honer-top {
      background-image: url('../assets/about-bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .title {
      line-height: 60px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }
    .container {
      position: relative;
      width: 1000px;
      margin: 0 auto;
      // padding-bottom: 50px;
      // z-index: 1000;
      background: rgb(247, 249, 250);
      .honor-item {
        .title {
          line-height: 20px;
          font-size: 15px;
          font-weight: 400;
          color: #000;
        }
        .honor-item-top {
          width: 100%;
          height: 0;
          padding-bottom: 100%;
          position: relative;
          .honor-image {
            position: absolute;
            left: 18%;
            top: 8%;
            width: 64%;
            height: 0;
            padding-bottom: 84%;
            background-image: url('../assets/gywm-6.jpg');
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }
}

.carousel /deep/ .ivu-carousel-arrow.left {
  left: -70px;
}
.carousel /deep/ .ivu-carousel-arrow.right {
  right: -70px;
}
.carousel /deep/ .ivu-carousel-arrow {
  background-color: #fff;
  color: #999;
}
.carousel /deep/ .ivu-icon {
  font-size: 20px;
}
.carousel /deep/ .ivu-carousel-dots li.ivu-carousel-active > button {
  opacity: 1;
  width: 24px;
  border-radius: 3px;
  background: rgb(21, 135, 255);
}

.carousel /deep/ .ivu-carousel-dots {
  position: relative;
  top: 30px;
}

.swiper {
  width: 1000px;
  .swiper-slide {
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // text-align: center;
    font-weight: bold;
    font-size: 20px;
    .item {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
    }
  }
}

.swiper-box {
  position: relative;
}
.swiper-pagination {
  position: absolute;
  bottom: -35px;
  width: 1000px;
  z-index: 1000;
  & /deep/ .swiper-pagination-bullet-active {
    width: 25px;
    border-radius: 3px;
  }
  & /deep/ .swiper-pagination-bullet {
    margin: 0 4px;
  }
}
.swiper-button-prev {
  left: -65px;
}
.swiper-button-next {
  right: -65px;
}

.swiper-button-prev,
.swiper-button-next {
  color: #000;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
}

.page1 {
  position: relative;
  width: 1000px;
  height: 480px;
  margin: auto;
  background: rgb(247, 249, 250);
  .more {
    padding-top: 50px;
  }
  .swiper2 {
    height: 400px;
    width: 900px;
    margin-left: 0;
    overflow: hidden;
    .box {
		.time {
			font-size: 40px;
			font-weight: 700;
			padding-top: 0 !important;
			color: rgb(69, 163, 50);
      cursor: pointer;
			&:first-child {
			  padding-top: 60px;
			}
		}
		.title {
			text-align: left;
			font-size: 17px;
			font-weight: 600;
			line-height: 60px;
		}
      .text {
		line-height: 50px;
		&.ellipsis {
			overflow: hidden;
			display: -webkit-box;
			word-break: break-all;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 5;
		}
		& /deep/ p {
			line-height: 30px !important;
		}
      }
      .showP {
        width: 900px;
        visibility: hidden;
        position: absolute;
        right: 9999px;
        & /deep/ p {
          line-height: 30px !important;
        }
      }
    }
  }
  .right {
    position: absolute;
    top: 0;
    right: 0;
    // transform: translate(0, -50%);
    border-right: 1px solid #d9d9da;
    padding-bottom: 100px;
    .swiper1 {
      height: 280px;
      width: 70px;
      overflow: hidden;
      text-align: center;
      margin-top: 100px;
      &.gallery-thumbs .swiper-slide {
        .time {
          font-size: 15px;
          font-weight: 400;
          color: #999;
          cursor: pointer;
        }
      }
      &.gallery-thumbs .swiper-slide-active {
        .time {
          font-size: 17px;
          font-weight: 500;
          border-right: 2px solid #000;
          color: rgb(69, 163, 50);
        }
      }
    }
  }
}
.swiper-slide {
  height: auto;
}
.swiper-container-vertical {
  /deep/ .swiper-wrapper {
    flex-direction: column;
  }
}
</style>